module.exports = __webpack_public_path__ + "/svg/information.516d876ff3c45b3fe23b9939308158bd.svg";